import { DartsGameScore, EventScoreboard } from '@frontend/sports/betting-offer/feature/model';
import { Sitecore } from '@frontend/sports/common/client-config-data-access';

import { PairScoreboardViewModel } from './pair-scoreboard.viewmodel';
import { DartsScoreboardStats } from './scoreboard-stats';

export class DartsScoreboardViewModel extends PairScoreboardViewModel {
    override stats: DartsScoreboardStats;
    override bestOfLegs: number;
    override bestOfSets: number;

    constructor(public sitecore: Sitecore) {
        super();
        this.stats = new DartsScoreboardStats();
    }

    protected override fillFromScoreboard(scoreboard: EventScoreboard): void {
        super.fillFromScoreboard(scoreboard);
        this.stats.fillDartsStats(scoreboard);
        this.bestOfLegs = scoreboard.bestOfLegs || 0;
        this.bestOfSets = scoreboard.bestOfSets || 0;

        const score = scoreboard.getScore<DartsGameScore>();
        if (score) {
            this.matchType = score.matchType;
        }
    }

    override updateFromScoreboard(scoreboard: EventScoreboard): void {
        super.updateFromScoreboard(scoreboard);
        this.stats.fillDartsStats(scoreboard);
        this.bestOfLegs = scoreboard.bestOfLegs || 0;
        this.bestOfSets = scoreboard.bestOfSets || 0;
    }
}
